import { useLayoutEffect, useState } from 'react';

type props = {
  collectionPath?: string;
  currentDocId: string;
  seriesIdList?: string[] | null;
};

/**
 * 시리즈 모드 전용 이전/다음 글 탐색 훅.
 * 비시리즈(일반 글) 탐색은 `usePrevNextDocCursor`를 사용.
 *
 * spec: /spec/prd/posting_prev_next_cursor_prd.md
 *
 * 시리즈 모드: `${path}Series.postingList`(asc) 기준 index 이동, 순환 없음.
 */
export function usePrevNextDocId({
  currentDocId,
  seriesIdList,
}: props) {
  const [prevID, setPrevID] = useState<string | null>(null);
  const [nextID, setNextID] = useState<string | null>(null);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useLayoutEffect(() => {
    if (!seriesIdList || seriesIdList.length === 0) {
      setPrevID(null);
      setNextID(null);
      setCurrentIndex(-1);
      return;
    }

    const _currentIndex = seriesIdList.findIndex((id) => id === currentDocId);
    setCurrentIndex(_currentIndex);

    if (_currentIndex === -1) {
      setPrevID(null);
      setNextID(null);
      return;
    }

    // 🎯 시리즈 모드: 순환하지 않고 끝에서 null 리턴
    const prevIndex = _currentIndex - 1;
    const nextIndex = _currentIndex + 1;

    setPrevID(prevIndex >= 0 ? seriesIdList[prevIndex] : null);
    setNextID(
      nextIndex < seriesIdList.length ? seriesIdList[nextIndex] : null,
    );
  }, [seriesIdList, currentDocId]);

  return { prevID, nextID, currentIndex };
}
